var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":this}},[_c('loader',{attrs:{"loader":_vm.loader}}),_vm._t("default",null,{"app":this})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }